import React from 'react';

// Section header for the home dashboard (title + icon + "view all").
const H2Homepage = ({ title, iconName, onViewAll }) => (
    <div className="hp-head">
        <div className="hp-head-title">
            {iconName && <img className="hp-head-icon" src={iconName} alt="" aria-hidden="true" />}
            <span>{title}</span>
        </div>
        {onViewAll && <button className="hp-head-link" onClick={onViewAll}>צפייה בהכל</button>}
    </div>
);

export default H2Homepage;
